<template lang="html">
  <div class="main">
    <div class="success" v-if="show&&show !=='none'">{{message.info1}}<a href="/app/login"> {{message.login}} </a>，{{message.login}}Cydex</div>
    <div class="fail" v-if="!show&&show !=='none'">{{message.info2}}</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      message: {
        login: this.$lang.ui.form.login,
        info1: this.$lang.ui.notice.l100,
        info2: this.$lang.ui.notice.l101
      },
      show: 'none'
    }
  },
  created () {
    this.active()
    this.$store.dispatch('activeApp', true)
    this.$store.dispatch('alertWarn', false)
  },
  methods: {
    active () {
      var token = this.$route.query.token
      this.$http.post('/cydex/api/v1/invite/accept', {
        'token': token
      })
        .then(response => {
          this.show = true
        })
        .catch(error => {
          if (error) {
            this.show = false
          }
        })
    }
  }
}
</script>

<style lang="css" scoped>
.main {
  margin-top: 120px;
  text-align: center;
  font-size: 16px;
}
a {
  color: #007bc5;
}
</style>
